import { PlatformLocation } from '@angular/common'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { CdcTokenResponse } from '@app/core/models/custom/auth.model'
import { GigyaAuthData } from '@app/core/models/custom/gigya.model'
import { AuthConfigService, OccEndpointsService } from '@spartacus/core'
import { Observable } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class CustomAuthAdapter {
  private readonly occEndpoints = inject(OccEndpointsService)
  private readonly authConfigService = inject(AuthConfigService)
  private readonly platformLocation = inject(PlatformLocation)
  private readonly http = inject(HttpClient)

  getCdcToken (authData: GigyaAuthData): Observable<CdcTokenResponse> {
    const clientId: string = this.authConfigService.getClientId()
    const redirectUrl: string = this.platformLocation.href

    const endpoint: string = this.occEndpoints.buildUrl('custom', {
      scope: 'cdcToken',
      queryParams: { ccgLogin: true, countryIsoCode: 'US' }
    })

    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
    const body: string = `gigyaData=${JSON.stringify(authData)}&client_id=${clientId}&redirect_url=${redirectUrl}&rememberMe=${authData.rememberMe ?? false}`

    return this.http.post<CdcTokenResponse>(endpoint, body, { headers })
  }
}
